<template>
    <div class="default_wrap">
        <img src="~@/assets/images/user/housev2/default_img.png" alt="">
        <h1 v-if="nType==1">非本人项目交付档案无查看权限</h1>
        <div v-if="nType==2">
            <h1>暂未查询到您的项目交付档案</h1>
            <template>
                <p>项目交付档案主要针对购买A.O.史密斯智慧集成系统且<br/>施工时间在2022年1月10日后的项目。请使用<br/>购买A.O.史密斯该系统预留的手机号码进入查询。</p>
            </template>
        </div>
    </div>
</template>

<script>
import {getReportShare} from "@/js/member/mynews";

export default {
    name: "error",
    data(){
        return{
            nType:1,
            shareTimeLog:null,
        }
    },
    created() {
        this.nType=this.$route.query.type
        if (this.$route.query.shareId>0) {
            let shareData = {
                url:window.location.href,
                project_uuid:this.$route.query.projectmgnid || this.$route.query.project_uuid,
                id: this.$route.query.shareId,
            }
            getReportShare(shareData).then(res=>{
                shareData.log_id=res.data.data.result.log_id
                this.shareTimeLog= setInterval(()=>{
                    getReportShare(shareData)
                },2000)
            })
        }
    },
    beforeDestroy() {
        clearInterval(this.shareTimeLog)
        this.shareTimeLog=null
    },
}
</script>

<style scoped lang="scss">
.default_wrap {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: $userBgV2;
    position: relative;
    z-index: 12;

    img {
        display: block;
        width: 100%;
        margin-top: 12%;
    }

    h1 {
        width: 100%;
        text-align: center;
        font-size: 36px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: bold;
        color: #000000;
        line-height: 54px;
        letter-spacing: 1px;
    }

    p {
        margin-top: 24px;
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        color: #666666;
        line-height: 48px;
        letter-spacing: 1px;
    }
}
</style>
